export enum BrokerBuySteps {
  Step1 = 'step1',
  Step2 = 'step2',
  Step3 = 'step3',
  Step4 = 'step4',
  Step5 = 'step5',
  Step6 = 'step6',
  Step7 = 'step7',
  Step8 = 'step8',
  Step9 = 'step9',
  Step10 = 'step10',
  Step11 = 'step11',
  Step12 = 'step12',
  Step13 = 'step13',
  Step14 = 'step14',
  Step15 = 'step15',
  Step16 = 'step16',
  Step17 = 'step17',
  Step18 = 'step18',
  Step19 = 'step19',
  Step20 = 'step20',
  Step21 = 'step21',
  Step22 = 'step22',
  Step23 = 'step23',
  Step24 = 'step24',
  Step25 = 'step25',
  Step26 = 'step26',
  Step27 = 'step27',
}

export enum BrokerBuyLinks {
  Step1 = '/commercial-combined/steps/step1',
  Step2 = '/commercial-combined/steps/step2',
  Step3 = '/commercial-combined/steps/step3',
  Step4 = '/commercial-combined/steps/step4',
  Step5 = '/commercial-combined/steps/step5',
  Step6 = '/commercial-combined/steps/step6',
  Step7 = '/commercial-combined/steps/step7',
  Step8 = '/commercial-combined/steps/step8',
  Step9 = '/commercial-combined/steps/step9',
  Step10 = '/commercial-combined/steps/step10',
  Step11 = '/commercial-combined/steps/step11',
  Step12 = '/commercial-combined/steps/step12',
  Step13 = '/commercial-combined/steps/step13',
  Step14 = '/commercial-combined/steps/step14',
  Step15 = '/commercial-combined/steps/step15',
  Step16 = '/commercial-combined/steps/step16',
  Step17 = '/commercial-combined/steps/step17',
  Step18 = '/commercial-combined/steps/step18',
  Step19 = '/commercial-combined/steps/step19',
  Step20 = '/commercial-combined/steps/step20',
  Step21 = '/commercial-combined/steps/step21',
  Step22 = '/commercial-combined/steps/step22',
  Step23 = '/commercial-combined/steps/step23',
  Step24 = '/commercial-combined/steps/step24',
  Step25 = '/commercial-combined/steps/step25',
  Step26 = '/commercial-combined/steps/step26',
  Step27 = '/commercial-combined/steps/step27',
}
